import get from 'lodash.get';

export const selectShipmentFromCustomerDetails = (state) => get(state, 'shipmentFromCustomerDetails');
export const selectShipmentDetails = (state) => get(state, 'shipmentDetails');
export const selectFulfillmentPlanIdForShipmentDetailModalId = (state, props) =>
  get(state, `${props.shipmentDetailModalId}.fulfillmentPlanId`);
export const selectShipmentDetailsByShipmentDetailModalId = (state, props) => get(state, `${props.shipmentDetailModalId}`);
export const selectShipmentDetailsModalIds = (state) => Object.keys(state);
